import React, {useContext, useEffect} from "react";
import {Button, Col, Form, Row} from "react-bootstrap";
import {useIntl} from "react-intl";
import messages from "../../../i18n/messages";
import {getLearnedChars, updateRememberedChars} from "../../../utils/LearningUtil";
import {ModalContext} from "../../../contexts/modal/ModalContext";
import {LoadingContext} from "../../../contexts/loading/LoadingContext";
import CharElm from "../CharElm/CharElm";
import {AuthContext} from "../../../contexts/auth/AuthContext";
import MaxiIcon from "../../Maxiicon/MaxiIcon";
import {LEARN_CHARACTER_TYPE} from "../../../configuration/configurations";

const LearnChineseCharacter = () => {
    const intl = useIntl();
    const [, setModalContext] = useContext(ModalContext);
    const [, setLoadingContext] = useContext(LoadingContext);
    const [authContext,] = useContext(AuthContext);
    const [learnedChar, setLearnedChar] = React.useState([]);
    const [voiceDisabled, setVoiceDisabled] = React.useState(true);
    const [synthVoice, setSynthVoice] = React.useState(null);
    const [rememberedChar, setRememberedChar] = React.useState([]);
    const [rememberedList, setRememberedList] = React.useState([]);


    const onCheckClick = async (event, id) => {
        let rememberedCharList = [...rememberedList];
        if (event.target.checked) {
            if (!rememberedCharList.includes(id)) {
                rememberedCharList.push(id);
            }
        } else {
            if (rememberedCharList.includes(id)) {
                rememberedCharList = rememberedCharList.filter(charId => charId !== id);
            }
        }
        setRememberedList(rememberedCharList);
    }

    const getCheckedStatus = (id) => {
        return rememberedList.includes(id);
    }

    const renderLearnedChar = () => {
        return learnedChar.map(char => {
            return (
                <Col xs={4} sm={3} md={2} key={'char_' + char.id}>
                    <CharElm char={char.charWord} voiceDisabled={voiceDisabled} synthVoice={synthVoice}/>
                    {authContext.isAdmin &&
                    <Form.Check
                        type={'checkbox'}
                        id={'learned_char_' + char.id}
                        label={''}
                        onChange={(e) => onCheckClick(e, char.id)}
                        checked={getCheckedStatus(char.id)}
                        className={'char-check-box'}
                    />
                    }
                </Col>
            );
        });
    }

    const renderRememberedChar = () => {
        return rememberedChar.map(char => {
            return (
                <Col xs={4} sm={3} md={2} key={'char_' + char.id}>
                    <CharElm char={char.charWord} voiceDisabled={voiceDisabled} synthVoice={synthVoice}/>
                </Col>
            );
        });
    }

    useEffect(() => {
        fetchLearnedChar();
    }, []);

    useEffect(() => {
        const synth = window.speechSynthesis;
        let voiceList = synth.getVoices().filter(voice => voice.lang === 'zh-CN');
        if (voiceList.length === 0) {
            setSynthVoice(null);
            setVoiceDisabled(true);
        } else {
            const idx = voiceList.findIndex(voice => voice.name.toLowerCase() === 'Tingting'.toLowerCase());
            if (idx !== -1) {
                setSynthVoice(voiceList[idx]);
            } else {
                const idxYuShu = voiceList.findIndex(voice => voice.name.toLowerCase() === 'Yu-shu'.toLowerCase());
                if (idxYuShu !== -1) {
                    setSynthVoice(voiceList[idxYuShu]);
                } else {
                    setSynthVoice(voiceList[0]);
                }
            }
            setVoiceDisabled(false);
        }
    }, [learnedChar, rememberedChar]);


    async function fetchLearnedChar() {
        try {
            setLoadingContext({
                isLoading: true,
                loadingText: '',
            });
            const response = await getLearnedChars();
            if (!response.ok) {
                setModalContext({
                    isShow: true,
                    title: intl.formatMessage(messages.errMsgTitle),
                    content: intl.formatMessage(messages.errMsgServerError),
                    onConfirm: () => {},
                });
            } else if (response.status === 204) {
                // No content
            } else {
                const data = await response.json();
                let learnedChar = data.filter(char => char.learned === true && char.remembered === false);
                let rememberedChar = data.filter(char => char.learned === true && char.remembered === true);
                setLearnedChar(learnedChar);
                setRememberedChar(rememberedChar);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingContext({
                isLoading: false,
                loadingText: '',
            });
        }
    }

    const onRememberedButtonClick = async () => {
        try {
            setLoadingContext({
                isLoading: true,
                loadingText: '',
            });
            const response = await updateRememberedChars(LEARN_CHARACTER_TYPE.CHINESE, rememberedList,
                authContext.token);
            if (!response.ok) {
                setModalContext({
                    isShow: true,
                    title: intl.formatMessage(messages.errMsgTitle),
                    content: intl.formatMessage(messages.errMsgServerError),
                    onConfirm: () => {},
                });
            } else if (response.status === 204) {
                // No content
            } else {
                const data = await response.json();
                let learnedChar = data.filter(char => char.learned === true && char.remembered === false);
                let rememberedChar = data.filter(char => char.learned === true && char.remembered === true);
                setLearnedChar(learnedChar);
                setRememberedChar(rememberedChar);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingContext({
                isLoading: false,
                loadingText: '',
            });
        }
    }


    return (
        <>
            <Row>
                <Col xs={12}>
                    {intl.formatMessage(messages.learnedChineseCharacterLabel)}
                </Col>
            </Row>
            <br/>
            <Row>
                {renderLearnedChar()}
            </Row>
            {authContext.isAdmin &&
            <Row>
                <Col xs={12} sm={12} md={{span: 4, offset: 4}}>
                    <Button variant={"success"} onClick={onRememberedButtonClick}>
                        <MaxiIcon iconName={'faBrain'}/>&nbsp;{intl.formatMessage(messages.rememberedButtonLabel)}
                    </Button>
                </Col>
            </Row>
            }
            <hr/>
            <Row>
                <Col xs={12}>
                    {intl.formatMessage(messages.rememberedChineseCharacterLabel)}
                </Col>
            </Row>
            <br/>
            <Row>
                {renderRememberedChar()}
            </Row>
        </>
    );
}

export default LearnChineseCharacter;